<template>
  <section id="feather-icons">
    <div id="icons-container" class="d-flex flex-wrap">
      <b-card
        style="width: 100% !important"
        class="icon-card cursor-pointer text-center w-100 mb-2 mx-50 card-icon-new"
      >
        <b-tabs >
          <b-tab title="Desafios" active lazy>
            <div style="display: flex; flex-wrap: wrap">
              <div>
                <h3>Quiz</h3>
                <chartjs-component-doughnut-chart
                  :height="150"
                  :data="dados1.data"
                  :options="dados1.options"
                  class="mb-3"
                />
              </div>
              <div>
                <h3>Quiz Pós Teste</h3>
                <chartjs-component-doughnut-chart
                  :height="150"
                  :data="dados1.data"
                  :options="dados1.options"
                  class="mb-3"
                />
              </div>
              <div>
                <h3>Patrulha Pre Teste</h3>
                <chartjs-component-doughnut-chart
                  :height="150"
                  :data="obterDadosMock(10, 90)"
                  :options="dados1.options"
                  class="mb-3"
                />
              </div>
              <div>
                <h3>Patrulha Pós Teste</h3>
                <chartjs-component-doughnut-chart
                  :height="150"
                  :data="obterDadosMock(30, 70)"
                  :options="dados1.options"
                  class="mb-3"
                />
              </div>
              <div>
                <h3>Janelas e Tanques Pre Teste</h3>
                <chartjs-component-doughnut-chart
                  :height="150"
                  :data="obterDadosMock(60, 40)"
                  :options="dados1.options"
                  class="mb-3"
                />
              </div>
              <div>
                <h3>Janelas e Tanques Pós Teste</h3>
                <chartjs-component-doughnut-chart
                  :height="150"
                  :data="obterDadosMock(20, 80)"
                  :options="dados1.options"
                  class="mb-3"
                />
              </div>
              <div>
                <h3>Coleta e Reciclagem Pre Teste</h3>
                <chartjs-component-doughnut-chart
                  :height="150"
                  :data="obterDadosMock(60, 40)"
                  :options="dados1.options"
                  class="mb-3"
                />
              </div>
              <div>
                <h3>Coleta e Reciclagem Pós Teste</h3>
                <chartjs-component-doughnut-chart
                  :height="150"
                  :data="obterDadosMock(20, 80)"
                  :options="dados1.options"
                  class="mb-3"
                />
              </div>
            </div>
          </b-tab>
          <b-tab title="Ranking" lazy>
            <div style="display: flex; flex-wrap: wrap">
              <div>
                <h3>Escolas</h3>
                <chartjs-component-doughnut-chart
                  :height="150"
                  :data="dados1.data"
                  :options="dados1.options"
                  class="mb-3"
                />
              </div>
              </div>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </section>
</template>

<script>
import {
  BFormGroup,
  BRow,
  BCol,
  BForm,
  BInputGroup,
  BInputGroupPrepend,
  BFormInput,
  BCard,
  BCardText,
  VBTooltip,
  BButton,
} from 'bootstrap-vue'
import { useClipboard } from '@vueuse/core'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useToast } from 'vue-toastification/composition'
import challengeModelService from '@/services/challengeModelService'
import { hideSpinner, showSpinner } from '@/services/spinService'
import ChartjsComponentDoughnutChart from '../charts-and-maps/charts/chartjs/charts-components/ChartjsComponentDoughnutChart.vue'
import { BTabs, BTab } from 'bootstrap-vue'
import BCardCode from '@/@core/components/b-card-code'

export default {
  components: {
    BForm,
    BButton,
    BRow,
    BCol,
    BCard,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BCardText,
    BInputGroupPrepend,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    ChartjsComponentDoughnutChart,
    BTabs,
    BTab,
    BCardCode,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      tabIndex: 0,
      dados1: {
        options: {
          responsive: true,
          maintainAspectRatio: false,
          responsiveAnimationDuration: 500,
          cutoutPercentage: 60,
          //   legend: { display: false },
          tooltips: {
            callbacks: {
              label(tooltipItem, data) {
                const label = data.datasets[0].labels[tooltipItem.index] || ''
                const value = data.datasets[0].data[tooltipItem.index]
                const output = ` ${label} : ${value} %`
                return output
              },
            },
            // Updated default tooltip UI
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 8,
          },
        },
        data: {
          labels: ['Acertos', 'Erros'],
          datasets: [
            {
              labels: ['Acertos', 'Erros'],
              data: [80, 10],
              backgroundColor: ['#28c76f', '#b8c2cc'],
              borderWidth: 0,
              pointStyle: 'rectRounded',
            },
          ],
        },
      },
      modelSelected: null,
      models: {},
      seachQuery: '',
      icons: [
        'ActivityIcon',
        'AirplayIcon',
        'AlertCircleIcon',
        'AlertOctagonIcon',
        'AlertTriangleIcon',
        'AlignCenterIcon',
        'AlignJustifyIcon',
        'AlignLeftIcon',
        'AlignRightIcon',
        'AnchorIcon',
        'AlignRightIcon',
      ],
    }
  },
  computed: {
    filterIcons() {
      const seachQueryIcon = this.seachQuery.toLowerCase()
      return this.icons.filter(item =>
        item.toLowerCase().includes(seachQueryIcon)
      )
    },
  },
  methods: {
    obterDadosMock(valor1, valor2) {
      const dados = JSON.parse(JSON.stringify(this.dados1.data))
      if (dados.datasets) dados.datasets.at(0).data = [valor1, valor2]
      return dados
    },
  },
  mounted() {
    //   this.fetchModels()
  },
  setup() {
    const toast = useToast()
    const { copy } = useClipboard()

    const copyIconName = iconName => {
      copy(iconName)

      toast({
        component: ToastificationContent,
        props: {
          title: 'Modelo Selecionado!',
          icon: 'CheckIcon',
          variant: 'success',
        },
      })
    }

    return {
      copyIconName,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/ui-feather.scss';
</style>
